import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';
import { generalConfiguratorDomain } from '../Configurator/selectors/general';
import { ActivePanel } from '../Configurator/constants/general';

/**
 * Direct selector to the paintPanel state domain
 */

const selectPaintPanelDomain = (state: ApplicationRootState) =>
  state.paintPanel || initialState;

export const selectPaintPanel = () =>
  createSelector(selectPaintPanelDomain, substate => substate);

export const makeSelectPaintColor = () =>
  createSelector(selectPaintPanelDomain, substate => substate.color);

export const makeSelectIsPaintMode = () =>
  createSelector(
    generalConfiguratorDomain,
    substate => substate.colorsPanel === ActivePanel.paint,
  );
